module.exports = __webpack_public_path__ + "static/media/zalo-zns.fe86cab7.png";